import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenVideoPreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-video-preview-data.interface';
import { VideoFormat } from '../../../../../../../utils/youtube-format-helper';
import { YoutubeShortsAdTvShellComponent } from './youtube-shorts-ad-tv-shell.component';

/**
 * Shorts ad for the 1:1 creative on the TV app: the square fills the screen's
 * height, so it reaches most of the way across and leaves only a narrow band.
 */
@Component({
    selector: 'app-gen-youtube-shorts-ad-tv-square',
    imports: [YoutubeShortsAdTvShellComponent],
    template: '<app-gen-youtube-shorts-ad-tv-shell [data]="data" [format]="format" />',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class YoutubeShortsAdTvSquarePreviewComponent {
  @Input() data!: GenVideoPreviewData;

  readonly format: VideoFormat = '1:1';
}
